export const tableConfigRO = [
  {
    name: "cabang",
    label: "Cabang",
    options: {
      setCellHeaderProps: () => ({
        style: { width: "25%", minWidth: "25%", textAlign: "center" },
      }),
    },
  },
  {
    name: "",
    label: "Unit Entri",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { width: "25%", minWidth: "25%", textAlign: "center" },
      }),
    },
  },
  {
    name: "",
    label: "RO H23",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { width: "25%", minWidth: "25%", textAlign: "center" },
      }),
    },
  },
  {
    name: "",
    label: "Rate (%)",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { width: "25%", minWidth: "25%", textAlign: "center" },
      }),
    },
  },
];

export const tableConfigROYtd = [
  {
    name: "cabang",
    label: "Cabang",
    options: {
      setCellHeaderProps: () => ({
        style: { width: "25%", minWidth: "25%", textAlign: "center" },
      }),
    },
  },
  {
    name: "",
    label: "Januari",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { width: "100px", minWidth: "100px", textAlign: "center" },
      }),
    },
  },
  {
    name: "",
    label: "Januari Rate (%)",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { width: "100px", minWidth: "100px", textAlign: "center" },
      }),
    },
  },
  {
    name: "",
    label: "Februari",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { width: "100px", minWidth: "100px", textAlign: "center" },
      }),
    },
  },
  {
    name: "",
    label: "Februari  (%)",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { width: "100px", minWidth: "100px", textAlign: "center" },
      }),
    },
  },
  {
    name: "",
    label: "Maret",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { width: "100px", minWidth: "100px", textAlign: "center" },
      }),
    },
  },
  {
    name: "",
    label: "Maret  (%)",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { width: "100px", minWidth: "100px", textAlign: "center" },
      }),
    },
  },
  {
    name: "",
    label: "April",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { width: "100px", minWidth: "100px", textAlign: "center" },
      }),
    },
  },
  {
    name: "",
    label: "April  (%)",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { width: "100px", minWidth: "100px", textAlign: "center" },
      }),
    },
  },
  {
    name: "",
    label: "Mei",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { width: "100px", minWidth: "100px", textAlign: "center" },
      }),
    },
  },
  {
    name: "",
    label: "Mei  (%)",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { width: "100px", minWidth: "100px", textAlign: "center" },
      }),
    },
  },
  {
    name: "",
    label: "Juni",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { width: "100px", minWidth: "100px", textAlign: "center" },
      }),
    },
  },
  {
    name: "",
    label: "Juni  (%)",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { width: "100px", minWidth: "100px", textAlign: "center" },
      }),
    },
  },
  {
    name: "",
    label: "Juli",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { width: "100px", minWidth: "100px", textAlign: "center" },
      }),
    },
  },
  {
    name: "",
    label: "Juli  (%)",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { width: "100px", minWidth: "100px", textAlign: "center" },
      }),
    },
  },
  {
    name: "",
    label: "Agustus",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { width: "100px", minWidth: "100px", textAlign: "center" },
      }),
    },
  },
  {
    name: "",
    label: "Agustus  (%)",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { width: "100px", minWidth: "100px", textAlign: "center" },
      }),
    },
  },
  {
    name: "",
    label: "September",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { width: "100px", minWidth: "100px", textAlign: "center" },
      }),
    },
  },
  {
    name: "",
    label: "September  (%)",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { width: "100px", minWidth: "100px", textAlign: "center" },
      }),
    },
  },
  {
    name: "",
    label: "Oktober",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { width: "100px", minWidth: "100px", textAlign: "center" },
      }),
    },
  },
  {
    name: "",
    label: "Oktober  (%)",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { width: "100px", minWidth: "100px", textAlign: "center" },
      }),
    },
  },
  {
    name: "",
    label: "November",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { width: "100px", minWidth: "100px", textAlign: "center" },
      }),
    },
  },
  {
    name: "",
    label: "November  (%)",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { width: "100px", minWidth: "100px", textAlign: "center" },
      }),
    },
  },
  {
    name: "",
    label: "Desember",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { width: "100px", minWidth: "100px", textAlign: "center" },
      }),
    },
  },
  {
    name: "",
    label: "Desember  (%)",
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        style: { width: "100px", minWidth: "100px", textAlign: "center" },
      }),
    },
  },
];
